export default __webpack_public_path__ + "static/the-differance-is-clear-portrait-es_converted-0db0ab8a7113b10020397ac625f90051.mp4";